export default __webpack_public_path__ + "static/media/Dual-Use-Goods.4e2d0587.svg";